/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Hero_Tile_Phone_TitleInputs */

const en_home_hero_tile_phone_title = /** @type {(inputs: Home_Hero_Tile_Phone_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`24/7 Emergency Assistance`)
};

const fr_home_hero_tile_phone_title = /** @type {(inputs: Home_Hero_Tile_Phone_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assistance d'urgence 24/7`)
};

/**
* | output |
* | --- |
* | "24/7 Emergency Assistance" |
*
* @param {Home_Hero_Tile_Phone_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_hero_tile_phone_title = /** @type {((inputs?: Home_Hero_Tile_Phone_TitleInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Hero_Tile_Phone_TitleInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_hero_tile_phone_title(inputs)
	return fr_home_hero_tile_phone_title(inputs)
});